export default __webpack_public_path__ + "static/logo-556e96be61c42fd8502bd4f50c7f564c.png";